import { errors } from './assets/errors';
import { titles } from './assets/titles';
import { PaymentErrorInfo } from './errors';

/**
 * Payment errors that can be displayed to the user.
 * See more codes here: https://docs.stripe.com/error-codes
 */
export const paymentError: Map<string, PaymentErrorInfo> = new Map([
  [
    'bank_account_bad_routing_numbers',
    {
      title: titles.PAYMENT_METHOD_NOT_SUPPORTED,
      description: errors.CANNOT_BE_USED,
    },
  ],
  [
    'bank_account_declined',
    {
      title: titles.PAYMENT_METHOD_NOT_SUPPORTED,
      description: errors.CANNOT_BE_USED,
    },
  ],
  [
    'bank_account_restricted',
    {
      title: titles.PAYMENT_METHOD_NOT_SUPPORTED,
      description: errors.CANNOT_BE_USED,
    },
  ],
  [
    'bank_account_unusable',
    {
      title: titles.PAYMENT_METHOD_NOT_SUPPORTED,
      description: errors.CANNOT_BE_USED,
    },
  ],
  [
    'bank_account_verification_failed',
    {
      title: titles.PAYMENT_METHOD_NOT_SUPPORTED,
      description: errors.CANNOT_BE_USED,
    },
  ],
  [
    'billing_invalid_mandate',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.AUTHORISATION_REVOKED,
    },
  ],
  [
    'capture_charge_authorization_expired',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.AUTHORISATION_REVOKED,
    },
  ],
  [
    'capture_unauthorized_payment',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.AUTHORISATION_REVOKED,
    },
  ],
  [
    'card_decline_rate_limit_exceeded',
    {
      title: titles.CARD_DECLINED_TOO_MANY_TIMES,
      description: errors.CARD_DECLINED_TOO_MANY_TIMES,
    },
  ],
  [
    'card_declined',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
    },
  ],
  [
    'coupon_expired',
    { title: titles.COUPON_EXPIRED, description: errors.COUPON_EXPIRED },
  ],
  [
    'debit_not_authorized',
    {
      title: titles.PAYMENT_METHOD_NOT_SUPPORTED,
      description: errors.CANNOT_BE_USED,
    },
  ],
  [
    'email_invalid',
    { title: titles.EMAIL_INVALID, description: errors.EMAIL_INVALID },
  ],
  [
    'expired_card',
    { title: titles.CARD_EXPIRED, description: errors.CARD_EXPIRED },
  ],
  [
    'incorrect_address',
    {
      title: titles.CARD_ADDRESS_DOES_NOT_MATCH,
      description: errors.CARD_ADDRESS_DOES_NOT_MATCH,
    },
  ],
  [
    'incorrect_cvc',
    {
      title: titles.CARD_INVALID_CVC,
      description: errors.CARD_INVALID_SECURITY_CODE,
    },
  ],
  [
    'incorrect_number',
    {
      title: titles.CARD_INVALID_NUMBER,
      description: errors.CARD_INVALID_NUMBER,
    },
  ],
  [
    'incorrect_zip',
    {
      title: titles.POSTAL_CODE_INVALID,
      description: errors.CARD_POSTAL_CODE_INVALID,
    },
  ],
  [
    'insufficient_funds',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_NOT_ENOUGH_FUNDS,
    },
  ],
  [
    'invalid_cvc',
    {
      title: titles.CARD_INVALID_SECURITY_CODE,
      description: errors.CARD_INVALID_SECURITY_CODE,
    },
  ],
  [
    'invalid_expiry_month',
    {
      title: titles.CARD_INVALID_MONTH,
      description: errors.CARD_INVALID_EXPIRATION_MONTH,
    },
  ],
  [
    'invalid_expiry_year',
    {
      title: titles.CARD_INVALID_YEAR,
      description: errors.CARD_INVALID_EXPIRATION_YEAR,
    },
  ],
  [
    'invalid_number',
    {
      title: titles.CARD_INVALID_NUMBER,
      description: errors.CARD_INVALID_NUMBER,
    },
  ],
  [
    'lock_timeout',
    {
      title: titles.TOO_MANY_PAYMENT_REQUESTS,
      description: errors.TOO_MANY_PAYMENT_REQUESTS,
    },
  ],
  [
    'payment_method_bank_account_blocked',
    {
      title: titles.ACCOUNT_CANNOT_BE_USED,
      description: errors.ACCOUNT_CANNOT_BE_USED,
    },
  ],
  [
    'payment_method_billing_details_address_missing',
    {
      title: titles.BILLING_ADDRESS_MISSING,
      description: errors.ADDRESS_MISSING,
    },
  ],
  [
    'payment_method_customer_decline',
    {
      title: titles.CARD_3DS_DECLINED,
      description: errors.CARD_3DS_DECLINED,
    },
  ],
  [
    'payment_method_not_available',
    {
      title: titles.PAYMENT_METHOD_TEMPORARILY_UNAVAILABLE,
      description: errors.PAYMENT_METHOD_TEMPORARILY_UNAVAILABLE,
    },
  ],
  [
    'payment_method_provider_decline',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
    },
  ],
  [
    'payment_method_provider_timeout',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
    },
  ],
  [
    'postal_code_invalid',
    {
      title: titles.POSTAL_CODE_INVALID,
      description: errors.POSTAL_CODE_INVALID,
    },
  ],
  [
    'processing_error',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_INTERNAL_ERROR,
    },
  ],
  [
    'sepa_unsupported_account',
    {
      title: titles.ACCOUNT_SEPA_NOT_SUPPORTED,
      description: errors.ACCOUNT_SEPA_NOT_SUPPORTED,
    },
  ],
  [
    'setup_attempt_failed',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_ERROR,
    },
  ],
  [
    'setup_intent_authentication_failure',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_ERROR,
    },
  ],
  [
    'setup_intent_mandate_invalid',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_ERROR,
    },
  ],
  [
    'setup_intent_setup_attempt_expired',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_ERROR,
    },
  ],
  [
    'setup_intent_unexpected_state',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_ERROR,
    },
  ],
  [
    'shipping_address_invalid',
    {
      title: titles.ADDRESS_SHIPPING_INVALID,
      description: errors.ADDRESS_SHIPPING_INVALID,
    },
  ],
]);
